import * as React from 'react';

const defaultRoutingContextValue = [
    {
        goTo: ()=>null
    },
    {
        component: undefined,
        queryParams: {},
        currentRoute: '',
        basePath: '',
        signInMyAccountUrl: undefined,
        routerId: undefined
    }, 
];
const RoutingContext = /*#__PURE__*/ React.createContext(defaultRoutingContextValue);
const useRoutingContext = ()=>{
    const context = React.useContext(RoutingContext);
    if (!context) {
        throw new Error('useRoutingContext must be used within a RoutingContextProvider');
    }
    return context;
};

export { RoutingContext, defaultRoutingContextValue, useRoutingContext };
//# sourceMappingURL=context.js.map
